import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * This component updates the HTML lang attribute whenever the language changes
 */
const HtmlLangUpdater: React.FC = () => {
  const { i18n } = useTranslation();
  
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
  
  return null; // This component doesn't render anything
};

export default HtmlLangUpdater;